import { addPaymentMethod, } from '../types'

const initState = {
  data: null,
  error: null,
  loading: false,
}

export default function addPaymentMethodsReducer (state = initState, action) {
  switch (action.type) {
    
    case addPaymentMethod.ADD_PAYMENT_METHOD_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        data: null
      }
    
    case addPaymentMethod.ADD_PAYMENT_METHOD_PENDING:
      return {
        ...state,
        loading: true,
      }
    
    case addPaymentMethod.ADD_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        data: true,
        loading: false,
        error: null,
      }

    default:
      return state
  }
}
